import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import {
  indexRoute,
  problemStatementsRoute,
  problemStatementsRoute25,
  processFlowRoute,
  projectImplementationRoute,
  TeamImplementationRoute,
  venueRoute,
  sbhthemesRoute,
  updatesRoute,
  teamRoute,
  prizesRoute,
  eligibilityRoute,
  loginRoute,
  adminPortalRoute,
  contactUsRoute,
  faqRoute,
  rulesRoute,
  resultJuniorRoute,
  resultSeniorRoute,
  sbh2023Route,
  sbh2024Route,
} from "./Routes";
import { lazy, Suspense } from "react";
import { DataProvider } from "./contexts/Data";
import { UserProvider } from "./contexts/DataProvider";
import Team from "./pages/Teams/Team";
import { AuthProvider } from "./contexts/Auth";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import SbhSenior from "./pages/Result/SbhSenior";
import AutomatticConsoleMessage from "./pages/Home/Compliance";

// splitting different page bundles
const Home = lazy(() => import("./pages/Home/Home"));
const ProblemStatements = lazy(
  () => import("./pages/ProblemStatements/ProblemStatements")
);
const ProblemStatements25 = lazy(
  () => import("./pages/ProblemStatements25/ProblemStatements25")
);
const ProjectImplementation = lazy(
  () => import("./pages/ProjectImplementation/ProjectImplementation")
);
const TeamImplementation = lazy(
  () => import("./pages/TeamImplementation/TeamImplementation")
);
const Venue = lazy(() => import("./pages/Venue/Venue"));
const ThemePage = lazy(() => import("./pages/ThemePage/ThemePage"));
const Rules = lazy(() => import("./pages/Rules/Rules"));
const Updates = lazy(() => import("./pages/Updates/Updates"));
const ProcessFlow = lazy(() => import("./pages/ProcessFlow/ProcessFlow"));
const Prizes = lazy(() => import("./pages/Prizes/Prizes"));
const Eligibility = lazy(() => import("./pages/Eligibility/Eligibility"));
const Register = lazy(() => import("./pages/Login/Login"));
const AdminPortal = lazy(() => import("./pages/AdminPortal/AdminPortal"));
const ContactUs = lazy(() => import("./pages/ContactUs/ContactUs"));
const Faq = lazy(() => import("./pages/FAQ/Faq"));
const ResultSenior = lazy(() => import("./pages/Result/SbhSenior"));
const ResultJunior = lazy(() => import("./pages/Result/SbhJunior"));
const SBH2023 = lazy(() => import("./pages/SBH2023/SBH2023"));
const SBH2024 = lazy(() => import("./pages/SBH2024/SBH2024"));
const Error404 = lazy(() => import("./pages/Error404/Error404"));

function App() {
  return (
    <BrowserRouter>
      <DataProvider>
        <UserProvider>
          <AuthProvider>
            <Routes>
              <Route path={indexRoute} element={<NavBar />}>
                <Route
                  index={true}
                  element={
                    <Suspense fallback={<></>}>
                      <Home />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={sbh2023Route}
                  element={
                    <Suspense fallback={<></>}>
                      <SBH2023 />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={sbh2024Route}
                  element={
                    <Suspense fallback={<></>}>
                      <SBH2024 />
                    </Suspense>
                  }
                ></Route>
                {/* <Route
                  path={problemStatementsRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ProblemStatements />
                    </Suspense>
                  }
                ></Route> */}
                <Route
                  path={problemStatementsRoute25}
                  element={
                    <Suspense fallback={<></>}>
                      <ProblemStatements25 />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={processFlowRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ProcessFlow />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={rulesRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Rules />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={teamRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Team />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={TeamImplementationRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <TeamImplementation />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={faqRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Faq />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={projectImplementationRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ProjectImplementation />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={venueRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Venue />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={sbhthemesRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ThemePage />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={updatesRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Updates />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={prizesRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Prizes />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={eligibilityRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Eligibility />
                    </Suspense>
                  }
                ></Route>
                {/* <Route
                path={EmailRoute}
                element={
                  <Suspense fallback={<></>}>
                    <EmailModule />
                  </Suspense>
                }
              ></Route> */}
                <Route
                  path={loginRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <Register />
                    </Suspense>
                  }
                ></Route>
                <Route path={adminPortalRoute} element={<PrivateRoute />}>
                  <Route
                    index={true}
                    element={
                      <Suspense fallback={<></>}>
                        <AdminPortal />
                      </Suspense>
                    }
                  />
                </Route>
                <Route
                  path={resultSeniorRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ResultSenior />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={resultJuniorRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ResultJunior />
                    </Suspense>
                  }
                ></Route>
                <Route
                  path={contactUsRoute}
                  element={
                    <Suspense fallback={<></>}>
                      <ContactUs />
                    </Suspense>
                  }
                ></Route>

                {/* 404 Error page - this catches all unmatched routes */}
                <Route
                  path="*"
                  element={
                    <Suspense fallback={<></>}>
                      <Error404 />
                    </Suspense>
                  }
                ></Route>
              </Route>
            </Routes>
          </AuthProvider>
        </UserProvider>
      </DataProvider>
      <AutomatticConsoleMessage />
      <img
        className="position-fixed up__arrow"
        style={{ bottom: "8px", right: "8px" }}
        width="40px"
        height="40px"
        alt=""
        src="/assets/arrow_up.png"
        role="button"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      />
    </BrowserRouter>
  );
}

export default App;
